import React, { Component } from 'react';
import PropTypes from 'prop-types';

class UserPic extends Component {
  static propTypes = {
    avatar: PropTypes.string,
    defaultAvatar: PropTypes.string,
    handleDelete: PropTypes.func,
    name: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      avatar: props.avatar,
      key: 0,
    };
  }

  uploadPhoto = e => {
    const { handleDelete, saveData } = this.props;

    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onload = e => {
        this.setState({
          avatar: e.target.result,
        });

        handleDelete(false);
        saveData(e, false, false);
      };

      reader.readAsDataURL(file);
    }
  };

  deleteAvatar = e => {
    e.preventDefault();

    const { handleDelete, saveData } = this.props;
    const { key } = this.state;

    this.setState({
      avatar: null,
      key: key + 1,
    });

    handleDelete(true);
    saveData(e, true, false);
  };

  render() {
    const { avatar, key } = this.state;
    const { defaultAvatar, name, disable } = this.props;

    return (
      <label
        className="user__pic"
        style={{ backgroundImage: `url(${avatar ? avatar : defaultAvatar}` }}
      >
        <input key={key} type="file" name={name} onChange={this.uploadPhoto} />
        {avatar && !disable ? (
          <button type="button" onClick={this.deleteAvatar}>
            delete
          </button>
        ) : null}
        {disable ? null : <div className="user__pic-icon"></div>}
      </label>
    );
  }
}

export default UserPic;
